/**
 * Extract a column of data with specified map function from data.
 * Each datum in the array is not visual data by default.
 * Specifying identity scale for related channel explicitly will treat them as visual data.
 */
export const Transform = ({ value }) => {
    return (data) => data.map(value);
};
Transform.props = {};
//# sourceMappingURL=transform.js.map